import Head from "next/head";

import { extractSubdomainfromUrl } from "@lib/utils/urlHelper";

const AppHead = ({ clientEnvironment, defaultClientName }: {
  clientEnvironment: EnhancedClientEnvironment;
  defaultClientName: string;
}) => {
  const { casting_domain, name } = clientEnvironment || {};
  const title = casting_domain ? `${extractSubdomainfromUrl(casting_domain)} | ${name || defaultClientName}` : 'Casting';

  return(
    <Head>
      <link
        rel="icon"
        href={clientEnvironment?.favicon_logo_url}
        key="favicon"
      />
      <title>{title}</title>
    </Head>
  );
};

export { AppHead } 